import axios from 'axios';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import $ from 'jquery';

const FaqForm = () => {
  const { user } = useSelector((state) => state.app);
  const [form, setForm] = useState({});
  const [isSuccess, setIsSuccess] = useState(null);
  const [formError, setFormError] = useState({});
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name,
        email: user.email,
      });
      setFormError({
        name: { isError: 2 },
        email: { isError: 2 },
      });
    }
  }, [user]);

  useEffect(() => {
    const errorLists = Object.values(formError);
    if (errorLists.length === 4) {
      for (let i = 0; i < errorLists.length; i++) {
        const { isError } = errorLists[i];
        if (isError === 1) {
          setIsDisabledBtn(false);
          break;
        }
        setIsDisabledBtn(true);
      }
    }
  }, [formError]);

  const checkInputs = (value, rules, id, name) => {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      const [min, length] = rule.split(':');
      if (
        rule === 'required' &&
        (value === null || value === undefined || value.trim() === '')
      ) {
        formError[id] = {
          isError: 1,
          message: `${name} không được bỏ trống.`,
        };
        setFormError({ ...formError });
        return;
      }
      if (rule === 'email') {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+([a-zA-Z\-0-9])?[a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)) {
          formError[id] = {
            isError: 1,
            message: `Email không hợp lệ.`,
          };
          setFormError({ ...formError });
          return;
        }
      }
      if (min === 'min' && value.length < Math.abs(length)) {
        formError[id] = {
          isError: 1,
          message: `${name} quá ngắn`,
        };
        setFormError({ ...formError });
        return;
      }
    }
    formError[id] = {
      isError: 2,
    };
    setFormError({ ...formError });
    return;
  };

  const handlerForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const onHandleSubmitFaq = (e) => {
    e.preventDefault();
    axios.post('/api/v1/faq', { ...form }).then(({ data }) => {
      if (data.success) {
        setForm({ ...form, title: '', content: '' });
        setFormError({});
        $('#modal-result').addClass('show').css('display', 'block');
      }
      setIsSuccess(data.success);
    });
  };

  return (
    <div className='faq__form'>
      <div className='header'>
        <h2>Bạn chưa tìm được câu hỏi của mình ?</h2>
        <p>
          Nếu bạn chưa tìm được câu hỏi và câu trả lời thoả mãn mong muốn của
          mình ? <br /> Đừng ngần ngại liên hệ chúng tôi
        </p>
      </div>
      <form action='' method='' onSubmit={onHandleSubmitFaq}>
        <div className='form-group' style={{ textAlign: 'left' }}>
          <label>Họ và tên</label>
          <input
            type='text'
            name='name'
            placeholder=''
            value={form.name || ''}
            style={
              formError.name?.isError === 1
                ? {
                    borderColor: '#ff3333',
                  }
                : {}
            }
            onChange={(e) => {
              handlerForm(e.target.value, 'name');
              checkInputs(e.target.value, ['required'], 'name', 'Họ và tên');
            }}
            onBlur={(e) => {
              checkInputs(e.target.value, ['required'], 'name', 'Họ và tên');
            }}
          />
          {formError.name && formError.name?.isError === 1 ? (
            <small className='text-danger p-1'>{formError.name?.message}</small>
          ) : (
            ''
          )}
        </div>
        <div className='form-group' style={{ textAlign: 'left' }}>
          <label>Email</label>
          <input
            type='email'
            name='email'
            placeholder=''
            value={form.email || ''}
            style={
              formError.email?.isError === 1
                ? {
                    borderColor: '#ff3333',
                  }
                : {}
            }
            onChange={(e) => {
              handlerForm(e.target.value, 'email');
              checkInputs(
                e.target.value,
                ['required', 'email'],
                'email',
                'Email'
              );
            }}
            onBlur={(e) => {
              checkInputs(
                e.target.value,
                ['required', 'email'],
                'email',
                'Email'
              );
            }}
          />
          {formError.email && formError.email?.isError === 1 ? (
            <small className='text-danger p-1'>
              {formError.email?.message}
            </small>
          ) : (
            ''
          )}
        </div>
        <div className='form-group' style={{ textAlign: 'left' }}>
          <label>Tiêu đề</label>
          <input
            type='text'
            name='title'
            placeholder=''
            value={form.title || ''}
            style={
              formError.title?.isError === 1
                ? {
                    borderColor: '#ff3333',
                  }
                : {}
            }
            onChange={(e) => {
              handlerForm(e.target.value, 'title');
              checkInputs(e.target.value, ['required'], 'title', 'Tiêu đề');
            }}
            onBlur={(e) => {
              checkInputs(e.target.value, ['required'], 'title', 'Tiêu đề');
            }}
          />
          {formError.title && formError.title?.isError === 1 ? (
            <small className='text-danger p-1'>
              {formError.title?.message}
            </small>
          ) : (
            ''
          )}
        </div>
        <div className='form-group' style={{ textAlign: 'left' }}>
          <label>Nội dung</label>
          <textarea
            placeholder=''
            value={form.content || ''}
            style={
              formError.content?.isError === 1
                ? {
                    borderColor: '#ff3333',
                    resize: 'none',
                  }
                : {
                    resize: 'none',
                  }
            }
            onChange={(e) => {
              handlerForm(e.target.value, 'content');
              checkInputs(e.target.value, ['required'], 'content', 'Nội dung');
            }}
            onBlur={(e) => {
              checkInputs(e.target.value, ['required'], 'content', 'Nội dung');
            }}
          ></textarea>
          {formError.content && formError.content?.isError === 1 ? (
            <small className='text-danger p-1'>
              {formError.content?.message}
            </small>
          ) : (
            ''
          )}
        </div>
        <button
          type='submit'
          className='btn_submit flex-center'
          style={
            !isDisabledBtn ? { background: ' #BBBBBB', color: '#ffffff' } : {}
          }
          disabled={!isDisabledBtn}
        >
          Gửi
        </button>
      </form>
    </div>
  );
};

export default FaqForm;
